export const phone = (phone) => {
	let currentNumber = '';

	if(typeof phone === 'string') {
		currentNumber =  phone.replace(/ /g,'');
		currentNumber = currentNumber.replace(/[{()}]/g, '');
		currentNumber = currentNumber.replace(/[-]/g, '');
		currentNumber = currentNumber.replace(/[.]/g, '');
	} else if(typeof phone === 'number') {
		currentNumber = phone.toString();
	}

	if(currentNumber.length === 10) {
		currentNumber =
			`(${currentNumber.substring(0, 3)}) ${currentNumber.substring(3, 6)}-${currentNumber.substring(6, 10)}`;
	} else {
		currentNumber = phone;
	}

	return currentNumber;
};
